export default __webpack_public_path__ + "static/media/live music.94099c3f.jpg";